<template>
  <div v-if="visible" class="iq-loader">
    <div class="iq-loader__content">
      <div class="iq-loader__menu-item">
        <span class="iq-loader__text">Starting research</span>
      </div>
      <div class="iq-loader__progress-container">
        <div class="iq-loader__progress-bar">
          <div class="iq-loader__progress-background"></div>
          <div 
            class="iq-loader__progress-fill" 
            :style="{ width: `${loading}%` }"
          ></div>
        </div>
        <button 
          class="iq-loader__stop-button" 
          @click="handleStop"
          aria-label="Stop loading"
        >
          <StopIcon :color="'#667085'" :fillColor="'#667085'" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import StopIcon from './icons/StopIcon.vue';
import './iqLoader.css';

/**
 * IQLoader Component
 * Displays a loading progress bar with stop functionality for IQ AI processing
 */

const props = defineProps({
  /**
   * Loading progress percentage (0-100)
   */
  loading: {
    type: Number,
    default: 0,
    validator: (value) => value >= 0 && value <= 100
  },
  /**
   * Control component visibility externally
   * If not provided, component manages its own visibility
   */
  modelValue: {
    type: Boolean,
    default: undefined
  }
});

const emit = defineEmits(['stop', 'update:modelValue']);

const internalVisible = ref(true);

// Use external modelValue if provided, otherwise use internal state
const visible = computed(() => {
  if (props.modelValue !== undefined) {
    return props.modelValue;
  }
  return internalVisible.value;
});

const handleStop = () => {
  emit('stop');
  internalVisible.value = false;
  if (props.modelValue !== undefined) {
    emit('update:modelValue', false);
  }
};

// Watch for external visibility changes
watch(() => props.loading, (newValue) => {
  if (newValue >= 100) {
    // Optionally hide when complete
    // visible.value = false;
  }
});
</script>

